export default __webpack_public_path__ + "2b2c045380db0f2fc736a92dcbd8c932.png";